import { jump2TemplateMethod } from './base'
import { WX_PATH_PREFIX } from './mp-const'

export function getIPath() {
  return '/native/auth'
}

export enum AUTH_PAGE_TYPE {
  entrance = 'entrance',
  guest = 'guest',
  host = 'host',
  steward = 'steward',
}

/**
 * [$jump2profile 跳转到实名认证]
 */
export default function jump2auth({ pageType }: { pageType: AUTH_PAGE_TYPE }) {
  jump2TemplateMethod({
    useIphx: true,
    iPath: getIPath(),
    mpPathMap: {
      dianping_wxapp: `${WX_PATH_PREFIX.dianpingSub}/dynamic-page/index?case=pages-me-identification-index`,
      group_wxapp: `${WX_PATH_PREFIX.meituan}/me/identification`,
      hotel_wxapp: `${WX_PATH_PREFIX.hotel}/me/identification`,
      phoenix_wxapp: `${WX_PATH_PREFIX.phx}/me/identification`,
    },
    rnPathConfig: {
      versions: { phx: '4.9.0', meituan: '11.7.200', dianping: '10.43.0' },
      mrn_entry: 'user-info',
      mrn_component: 'zhenguo-user-verify',
      mrn_translucent: true,
      params: {
        pageType,
      },
    },
  })
}
